import request from "#/utils/request";
const api = "/api";
const h5api = "/h5-api";

//

export function createOrder(data) {
  return request({
    url: h5api + "/v1/cash/charge/create",
    method: "post",
    data,
  });
}
//

export function verifyReceipt(data) {
  return request({
    url: h5api + "/v1/cash/charge/verify_receipt",
    method: "post",
    data,
  });
}

//
export function getChargeProducts(rechargeUid) {
  return request({
    url: h5api + "/v1/cash/charge/product",
    method: "post",
    rechargeUid,
  });
}

export function getPhilippineCoinProducts(rechargeUid) {
  return request({
    url: h5api + '/v1/cash/charge/coin/product',
    method: 'post',
    rechargeUid,
  });
}

export function getGemChargeProducts(data) {
  return request({
    url: h5api + "/v1/cash/charge/gem/product",
    method: "post",
    data,
  });
}

export function getVipGemChargeProducts(userId) {
  const normalizedUserId = Number(userId)
  const hasUserId = Number.isFinite(normalizedUserId) && normalizedUserId > 0

  return request({
    url: h5api + "/v1/cash/charge/vip-gem/product",
    method: "post",
    data: hasUserId ? { user_id: normalizedUserId } : {},
    rechargeUid: hasUserId ? normalizedUserId : undefined,
  });
}

export function getUser(data) {
  return request({
    url: h5api + "/v1/cash/user/check",
    method: "post",
    data,
  });
}

export function getGemUser(data) {
  return request({
    url: h5api + "/v1/cash/gem/user/check",
    method: "post",
    data,
  });
}

export function checkVipGemUser(data) {
  return request({
    url: h5api + "/v1/cash/charge/vip-gem/user/check",
    method: "post",
    data,
  });
}

export function getChargeProductIten(pid, payItemType, rechargeUid) {
  return request({
    url: `${h5api}/v1/cash/charge/product/${pid}`,
    method: "get",
    rechargeUid,
    params: {
      payItemType
    }
  });
}
